<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Detalle de Fechas Proyectadas
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-4">
      <div v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p>Cargando detalle...</p>
      </div>
      <div v-else-if="error">
        <v-alert type="error" dense>{{ error }}</v-alert>
      </div>
      <div v-else>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="text-h6">{{ programa.codigo }} - {{ programa.nombre_compuesto }}</v-list-item-title>
            <v-list-item-subtitle>
              Fecha Matrícula: <strong>{{ programa.fecha_matriculacion || 'No definida' }}</strong>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-timeline dense clipped class="mt-4">
          <v-timeline-item
            v-for="fecha in sortedFechas"
            :key="fecha.id"
            :color="isPast(fecha.fecha_proyectada) ? 'grey' : 'primary'"
            small
          >
            <v-row justify="space-between">
              <v-col cols="7">
                <strong>{{ traducirTipoFecha(fecha.tipo_fecha) }}</strong>
                <div class="text-caption">{{ fecha.fecha_proyectada }}</div>
              </v-col>
              <v-col class="text-right" cols="5">
                <v-chip v-if="fecha.estado_destino_codigo" small :color="getColorForEstado(fecha.estado_destino_codigo)">
                  {{ fecha.estado_destino_codigo }}
                </v-chip>
                <div class="text-caption">Día {{ fecha.dias_desde_matricula }}</div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="recalcularFechas"
        :loading="recalculando"
        :disabled="!programa.fecha_matriculacion"
      >
        <v-icon left>mdi-refresh</v-icon>
        Recalcular
      </v-btn>
      <v-btn color="grey" text @click="$emit('close')">
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import xaxios from '@/xaxios';

const API_URL = `${process.env.VUE_APP_API_REST}/api/v1`;

export default {
  name: 'FechasProyectadasDetalle',
  props: {
    programaId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      programa: {},
      loading: false,
      recalculando: false,
      error: null,
    };
  },
  computed: {
    sortedFechas() {
      if (!this.programa.fechas_proyectadas) return [];
      return [...this.programa.fechas_proyectadas].sort((a, b) => a.dias_desde_matricula - b.dias_desde_matricula);
    },
  },
  watch: {
    programaId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.fetchDetalle();
        }
      },
    },
  },
  methods: {
    async fetchDetalle() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await xaxios.get(`${API_URL}/programa/${this.programaId}/fechas-proyectadas`);
        this.programa = data;
      } catch (err) {
        this.error = 'Error al cargar el detalle del programa.';
        window.console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async recalcularFechas() {
      this.recalculando = true;
      try {
        const { data } = await xaxios.post(`${API_URL}/programa/${this.programaId}/fechas-proyectadas/recalcular`);
        this.programa = data;
        this.$root.$notify.show('Fechas recalculadas con éxito.', { color: 'success' });
        this.$emit('recalculated'); // Notificar al padre que se recalculó
      } catch (err) {
        this.$root.$notify.show('Error al recalcular las fechas.', { color: 'error' });
        window.console.error(err);
      } finally {
        this.recalculando = false;
      }
    },
    traducirTipoFecha(tipo) {
      const map = {
        FIN_CAMPANIA: 'Fin de campaña regular',
        INICIO_ARRASTRE: 'Inicio de arrastre',
        FIN_ARRASTRE: 'Fin de arrastre',
        INICIO_ARRASTRE_CRITICO: 'Inicio de arrastre crítico',
        FIN_ARRASTRE_CRITICO: 'Fin de arrastre crítico',
        INICIO_MODULO_0: 'Inicio posible de Módulo 0',
      };
      return map[tipo] || tipo;
    },
    isPast(fecha) {
      return new Date(fecha) < new Date();
    },
    getColorForEstado(codigo) {
       const colores = {
        PROXIMO: 'grey', CAMPANIA: 'green', ARRASTRE: 'yellow darken-2',
        ARRASTRE_CRITICO: 'orange', INICIADO_MODULO_0: 'blue',
        DESARROLLO: 'blue darken-3', CULMINADO: 'purple', DADO_DE_BAJA: 'red',
      };
      return colores[codigo] || 'grey';
    }
  },
};
</script>